import Route from '@ember/routing/route'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'

export default class MathseedsPrimeDashboardTableRoute extends Route {
  queryParams = {
    sort: {
      replace: true,
    },
    pageNumber: {
      replace: true,
    },
    perPage: {
      replace: true,
    },
  }

  model() {
    const {
      uiScope,
      period,
      scopedData: { students: scopedStudents },
    } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const isDataPresent = scopedStudents.length !== 0

    return { uiScope, period, scopedStudents, isDataPresent }
  }
}
